module.exports = __webpack_public_path__ + "media/brands/daimler-benz-847ee7db.png";